<template>
  <div id="app">
    <div class="app-wrapper">
      <Header />
      <transition name="page" mode="out-in">
        <router-view></router-view>
      </transition>
      <Footer />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueParallaxJs from '@/directives/parallax'
import _ from 'lodash'

import './filters'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

import VueGtm from 'vue-gtm';

Vue.use(VueGtm, {
  id: 'GTM-N4TF6ZN', // Your GTM ID
});

Vue.use(VueParallaxJs, ({
  minWidth: 800
}))

// Use lodash globally
Object.defineProperty(Vue.prototype, '$_', { value: _ });

export default {
  components: {
    Header,
    Footer
  },
  mounted() {
    // Scroll 1px in order to Parallax fire after load
    window.scrollTo(0, 2)
  },
  metaInfo() {
    return {
      title: this.$i18n.t('appTitle'),
      links: [
        { rel: 'canonical', href: window.location.href }
      ],
      // Define meta tags here.
      meta: [
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        { name: 'description', content: 'Sign up for fast credit card integration for your webshop! Accept with WooCommerce Visa and Mastercard Payments (with 3D Secure) in euros (€).' }
      ]
    }
  }
}
</script>

<style lang="scss">
  //Vendor
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  // Custom
  @import 'scss/main';
</style>
